import {SelectBonusModule, SelectBonusView} from '@gongxigames/framework/slot/modules/selectBonus';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import {ModuleState} from '@gongxigames/framework/slot';

// @ts-ignore
export class SelectBonusBasicState extends ModuleState<SelectBonusView, SelectBonusModule> {
    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.SELECT_BONUS_START, this.onSelectBonusStart.bind(this));
        this.setEventHandler(FlowModuleEvents.SELECT_BONUS_RESTORED, this.onSelectBonusRestored.bind(this));
    }

    public onEnterState(): void {}

    public onLeaveState(): void {}

    protected onSelectBonusStart(): void {
        this.module.gotoState(SelectBonusModule.PLAYING_STATE);
    }

    protected onSelectBonusRestored(): void {
        this.module.isRestore = true;
        this.onSelectBonusStart();
    }
}
